module.exports = __webpack_public_path__ + "static/img/test_video.53027ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/temp/test_video.png
// module id = 512
// module chunks = 1